import {
  getAxiosClient,
} from './axios-client'

/**
 * @typedef {import('./js-doc').V2CreateProcessingNotesRequest} V2CreateProcessingNotesRequest
 * @typedef {import('./js-doc').V2UpdateProcessingNotesRequest} V2UpdateProcessingNotesRequest
 * @typedef {import('./js-doc').V2DeleteProcessingNotesRequest} V2DeleteProcessingNotesRequest
 * @typedef {import('./js-doc').V2ProcessingNotesResponse} V2ProcessingNotesResponse
 */


class ProcessingNotes {
  constructor () {
    this.baseURL = `processing-notes`
  }

  /**
   * Create a processing note
   * @param {V2CreateProcessingNotesRequest} payload - V2 create body
   * @returns {Promise<V2ProcessingNotesResponse>} - V2 response body
   */
  async create (payload) {
    const result = (await(await getAxiosClient(this.baseURL)).post(``, {
      ...payload,
    }))
    return result?.data
  }

  /**
   * Update a processing note
   * @param {string} id - id of the processing note
   * @param {V2UpdateProcessingNotesRequest} payload - V2 update body
   * @returns {Promise<V2ProcessingNotesResponse>} - V2 response body
   */
  async update (id, payload) {
    const result = (await(await getAxiosClient(this.baseURL)).patch(id, {
      ...payload,
    }))
    return result?.data
  }

  /**
   * Update a processing note
   * @param {string} id - id of the processing note
   * @param {V2UpdateProcessingNotesRequest} payload - V2 update body
   * @returns {Promise<V2ProcessingNotesResponse>} - V2 response body
   */
  async delete (id, payload) {
    const result = (await(await getAxiosClient(this.baseURL)).delete(id, { data: payload }))
    return result?.data
  }
}

export default ProcessingNotes
